import { CaCodeType } from 'models/contextActions';
import { useContextAction } from 'hooks/useContextAction';
import { EAIEntityTypeCode, PermissionError } from 'utils/constants';
import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import { setPermissionError } from 'features/eai/eaiSlice';
import { setActiveItem } from 'features/app/appSlice';
import { selectAccountInfoUserId } from 'features/account/accountSelectors';

export const usePageAccessGuard = (pageContextAction: CaCodeType): boolean => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector(selectAccountInfoUserId);

  const contextAction = useContextAction({
    actionCode: pageContextAction,
    resourceEntity: EAIEntityTypeCode.USER,
    entityIdentificator: userId
  });

  // not sure for now, so disable access
  if (contextAction.contextAction === undefined || !userId) {
    return false;
  }

  if (!contextAction.isAllowed && userId) {
    dispatch(setActiveItem([]));
    dispatch(setPermissionError(PermissionError.ACTION_ERROR));
    return false;
  }

  return true;
};
